// hooks/useDeepLinks.ts
import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { useHistory } from 'react-router-dom';

export const useDeepLinks = () => {
  const history = useHistory();

  useEffect(() => {
    let listener: { remove: () => void } | null = null;

    const setup = async () => {
      const handleAppUrlOpen = (event: { url: string }) => {
        const path = parseDeepLink(event.url);
        if (path) {
          setTimeout(() => history.push(path), 50);
        }
      };

      // Handle cold start deep links
      const launch = await App.getLaunchUrl();
      if (launch?.url) {
        const path = parseDeepLink(launch.url);
        if (path) {
          history.push(path);
        }
      }

      // ⬅️ Must await addListener in Capacitor 6
      listener = await App.addListener('appUrlOpen', handleAppUrlOpen);
    };

    setup();

    return () => {
      if (listener && typeof listener.remove === 'function') {
        listener.remove();
      }
    };
  }, [history]);
};

const parseDeepLink = (url: string): string | null => {
  try {
    let path = url;

    if (url.startsWith('oxchord://')) {
      path = url.replace('oxchord://', '');
    }

    if (url.startsWith('https://app.oxchord.com')) {
      path = url.replace('https://app.oxchord.com', '');
    }

    if (!path.startsWith('/')) {
      path = '/' + path;
    }

    return path;
  } catch (e) {
    console.error('Error parsing deep link:', e);
    return null;
  }
};